export default function guest({ next, }) {
    if (localStorage.getItem('authStatus')) {
        return next({
            name: 'limits'
        })

    }
    return next()
}